import React from 'react';
import PropTypes from 'prop-types';
import css from './FieldError.module.scss';

/**
 * The validation message every form element already renders for its own `error` prop, exposed for
 * the cases those props cannot cover: a control that takes no `error` prop, or an error that
 * belongs to a group of fields rather than to one of them.
 *
 * Renders nothing without a message, so callers can pass a possibly-empty error straight in.
 */
const FieldError = ({children, className = ''}) => {
  if (!children) {
    return null;
  }

  return (
    <span className={`${css.fieldError} ${className}`}>
      {children}
    </span>
  );
};

FieldError.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

export default FieldError;
